/**
 * Created by yqr on 2019/2/20.
 */
import * as API from './'

export default {
  //登出
  logout: params => {
    return API.POST('/sso/oauth/revokeToken', params)
  },
  info:params=>{
    return API.GET('/handle/sso/getInfo', params)
  },

  
/*************************start 登录相关接口**************************** */

oauth2Url: params => {
  return API.GET('/handle/sso/state', params)
},

applyToken: params => {
  return API.POST('/handle/sso/token', params)
},

passwordApplyToken: params => {
  return API.POST('/handle/sso/passwordGetToken', params)
},

/*************************end 登录相关接口**************************** */
}



// WEBPACK FOOTER //
// ./src/api/api_user.js